import type { IIntakeQuestionnaireDetails } from '../../types';
import type {
  IIntakeMedicalInfo,
  IIntakeMedicalSelection,
  IntakeMedicalSelectionType,
} from './types';

// Same as ensureIntakeFamily: diagnosis/selection creates return only the new row, so initialize
// medical_info (and null list fields) instead of dropping the row. id is unused in the UI.
export function ensureIntakeMedicalInfo(details: IIntakeQuestionnaireDetails): IIntakeMedicalInfo {
  if (!details.medical_info) {
    details.medical_info = {
      id: 0,
      allergies: null,
      special_diets: null,
      hearing_difficulty: null,
      hearing_screening_date: null,
      vision_difficulty: null,
      vision_screening_date: null,
      trauma_history: null,
      hospitalization_history: null,
      f84_severity_level: null,
      f84_diagnosis_provider_name: null,
      f84_diagnosis_city: null,
      f84_diagnosis_state: null,
      f84_diagnosis_year: null,
      child_delivery_type: null,
      child_gestational_age: null,
      child_weight_at_birth_pounds: null,
      child_weight_at_birth_ounces: null,
      child_sitting_up_age_months: null,
      child_crawling_age_months: null,
      child_walking_age_years: null,
      child_walking_age_months: null,
      child_standing_age_years: null,
      child_standing_age_months: null,
      child_babbling_age_months: null,
      child_first_word: null,
      child_second_word: null,
      child_first_words_age_months: null,
      diagnoses: [],
      early_interventions: [],
      pregnancy_issues: [],
      regressions: [],
    };
    return details.medical_info;
  }
  details.medical_info.diagnoses ??= [];
  details.medical_info.early_interventions ??= [];
  details.medical_info.pregnancy_issues ??= [];
  details.medical_info.regressions ??= [];
  return details.medical_info;
}

export function getIntakeMedicalSelectionArray(
  medicalInfo: IIntakeMedicalInfo,
  type: IntakeMedicalSelectionType,
): IIntakeMedicalSelection[] {
  if (type === 'EARLY_INTERVENTION') return medicalInfo.early_interventions;
  if (type === 'PREGNANCY_ISSUE') return medicalInfo.pregnancy_issues;
  return medicalInfo.regressions;
}

export function setIntakeMedicalSelectionArray(
  medicalInfo: IIntakeMedicalInfo,
  type: IntakeMedicalSelectionType,
  next: IIntakeMedicalSelection[],
) {
  if (type === 'EARLY_INTERVENTION') {
    medicalInfo.early_interventions = next;
    return;
  }
  if (type === 'PREGNANCY_ISSUE') {
    medicalInfo.pregnancy_issues = next;
    return;
  }
  medicalInfo.regressions = next;
}
